import {inAppBrowser} from '@helpers';
import {ConfigurationApplication} from '@application/Config';
import {openExternalLink} from '@router/helpers';

const SHARE_DIALOG_URL = 'https://www.facebook.com/dialog/share';

/*
 sharer.php cannot redirect back when the share ends, hence the Share Dialog. And in-app
 browsers navigate in the same window: Facebook's on iOS has no tabs, so the view window.open
 opened had no history of its own and closing the share left a blank screen.
*/
export const shareFacebook = async (url: string): Promise<void> => {
  const {facebookAppId} = ConfigurationApplication.retrieve();
  const returnUrl = `${window.location.origin}/web_redirect${window.location.pathname}`;

  const facebookUrl =
    `${SHARE_DIALOG_URL}?app_id=${facebookAppId}` +
    `&display=page` +
    `&href=${encodeURIComponent(url)}` +
    `&redirect_uri=${encodeURIComponent(returnUrl)}`;

  await openExternalLink({url: facebookUrl, sameWindow: inAppBrowser});
};
